import Vue from 'vue'
import VueYouTubeEmbed from 'vue-youtube-embed'

Vue.use(VueYouTubeEmbed)


// WEBPACK FOOTER //
// ./src/plugins/youtube.js